import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons inline ── */
const IconClose   = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconSearch  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUser    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBox     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconMoney   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="2" y="6" width="20" height="12" rx="2" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/><path d="M6 12h.01M18 12h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSpinner = () => (<span style={{display:'inline-block',width:14,height:14,border:'2px solid rgba(130,216,179,.3)',borderTopColor:'#4db88a',borderRadius:'50%',animation:'pm-spin .7s linear infinite'}}/>);

const METODOS = [
  {val:'yape',          label:'Yape'},
  {val:'plin',          label:'Plin'},
  {val:'transferencia', label:'Transferencia bancaria'},
  {val:'efectivo',      label:'Efectivo'},
  {val:'tarjeta',       label:'Tarjeta (manual)'},
  {val:'otro',          label:'Otro'},
];

const PASO_LABELS = ['Cliente', 'Producto', 'Confirmar'];

const INIT_FORM = {
  // Cliente
  usuario_id: null, nombre: '', email: '', telefono: '',
  // Producto
  producto_id: '', producto_titulo: '', producto_tipo: '', fuente: '', moodle_id: 0,
  precio: '', metodo_pago: 'yape', referencia_pago: '', notas: '',
  // Estado final
  estado: 'validado',
};

export default function ModalPagoManual({ onClose, onSuccess, showToast }) {
  const [paso,        setPaso]        = useState(1);
  const [form,        setForm]        = useState(INIT_FORM);
  const [guardando,   setGuardando]   = useState(false);

  /* Búsqueda de usuario */
  const [busEmail,    setBusEmail]    = useState('');
  const [resultados,  setResultados]  = useState([]);
  const [buscando,    setBuscando]    = useState(false);
  const [modoManual,  setModoManual]  = useState(false);

  /* Productos */
  const [productos,   setProductos]   = useState([]);
  const [loadProd,    setLoadProd]    = useState(false);
  const [filtroTipo,  setFiltroTipo]  = useState('todos');

  const [busProducto, setBusProducto] = useState('');



  function setF(k, v) { setForm(p => ({ ...p, [k]: v })); }

  /* Buscar usuario con debounce */
  useEffect(() => {
    if (busEmail.length < 2) { setResultados([]); return; }
    const t = setTimeout(async () => {
      setBuscando(true);
      try {
        const r = await fetch(`${API}?action=buscar_usuario&email=${encodeURIComponent(busEmail)}`);
        const j = await r.json();
        if (j.success) setResultados(j.data || []);
      } catch {}
      finally { setBuscando(false); }
    }, 350);
    return () => clearTimeout(t);
  }, [busEmail]);

  /* Cargar productos al llegar al paso 2 */
  useEffect(() => {
    if (paso !== 2 || productos.length > 0) return;
    setLoadProd(true);
    fetch(`${API}?action=productos_manual`)
      .then(r => r.json())
      .then(j => { if (j.success) setProductos(j.data || []); })
      .catch(() => {})
      .finally(() => setLoadProd(false));
  }, [paso]);

  /* Seleccionar usuario */
  function seleccionarUsuario(u) {
    setForm(p => ({
      ...p,
      usuario_id: u.id,
      nombre:     u.nombre + (u.apellido ? ' ' + u.apellido : ''),
      email:      u.email,
      telefono:   u.whatsapp || u.telefono || '',
    }));
    setBusEmail('');
    setResultados([]);
    setModoManual(false);
  }

  /* Seleccionar producto */
  function seleccionarProducto(prod) {
    setForm(p => ({
      ...p,
      producto_id:    prod.id,
      producto_titulo: prod.titulo.replace(/^\[Curso\] /, ''),
      producto_tipo:  prod.tipo,
      fuente:         prod.fuente,
      moodle_id:      prod.moodle_id || 0,
      precio:         prod.precio,
    }));
  }

  /* Validar pasos */
  function puedeAvanzar() {
    if (paso === 1) return form.nombre.trim() && form.email.includes('@');
    if (paso === 2) return form.producto_titulo && parseFloat(form.precio) > 0;
    return true;
  }

  /* Guardar */
  async function guardar() {
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=registrar_pago_manual`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form,
          precio: parseFloat(form.precio),
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message || 'Error al registrar');
      showToast(
        form.estado === 'validado'
          ? `Pago validado — ${j.data.codigo}`
          : `Pedido creado — ${j.data.codigo}`
      );
      onSuccess();
      onClose();
    } catch(e) {
      showToast(e.message, 'error');
    } finally {
      setGuardando(false);
    }
  }

  const prodFiltrados = productos.filter(p => {
    const matchTipo = filtroTipo === 'todos' || p.fuente === filtroTipo;
    const matchBus  = !busProducto || p.titulo.toLowerCase().includes(busProducto.toLowerCase());
    return matchTipo && matchBus;
  });

  return (
    <>
      <style>{`
        @keyframes pm-spin { to { transform:rotate(360deg); } }
        @keyframes pm-in   { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:none} }
        .pm-overlay { position:fixed;inset:0;z-index:1100;background:rgba(0,0,0,.5);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:1rem; }
        .pm-modal { background:#fff;border-radius:20px;width:100%;max-width:600px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,.2);animation:pm-in .25s ease; }
        .pm-head { display:flex;align-items:center;justify-content:space-between;padding:1.2rem 1.5rem;border-bottom:1px solid rgba(130,216,179,.15); }
        .pm-head h2 { font-size:1.05rem;font-weight:700;color:#111614;margin:0; }
        .pm-close { width:32px;height:32px;border-radius:8px;border:none;background:#f3f4f6;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#5a6a63; }
        .pm-steps { display:flex;gap:0;padding:0 1.5rem;border-bottom:1px solid rgba(130,216,179,.12); }
        .pm-step { display:flex;align-items:center;gap:.4rem;padding:.7rem 1rem .7rem 0;font-size:.8rem;font-weight:600;color:#9ca3af;border-bottom:2px solid transparent;cursor:default; }
        .pm-step--active { color:#4db88a;border-color:#4db88a; }
        .pm-step--done   { color:#4db88a; }
        .pm-step__num { width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:.7rem;font-weight:800;background:#f3f4f6;color:#9ca3af; }
        .pm-step--active .pm-step__num { background:#edfaf4;color:#4db88a; }
        .pm-step--done   .pm-step__num { background:#edfaf4;color:#4db88a; }
        .pm-body { flex:1;overflow-y:auto;padding:1.3rem 1.5rem;display:flex;flex-direction:column;gap:1rem; }
        .pm-field { display:flex;flex-direction:column;gap:.3rem; }
        .pm-field label { font-size:.78rem;font-weight:600;color:#111614; }
        .pm-field input,.pm-field select,.pm-field textarea { padding:.68rem .9rem;border:1.5px solid rgba(130,216,179,.3);border-radius:10px;font-family:inherit;font-size:.88rem;color:#111614;outline:none;background:#fff;transition:border-color .2s; }
        .pm-field input:focus,.pm-field select:focus { border-color:#4db88a;box-shadow:0 0 0 3px rgba(130,216,179,.12); }
        .pm-grid2 { display:grid;grid-template-columns:1fr 1fr;gap:.8rem; }
        .pm-req { color:#dc2626; }
        .pm-foot { display:flex;justify-content:space-between;align-items:center;padding:1rem 1.5rem;border-top:1px solid rgba(130,216,179,.12); }
        .pm-btn-pri { display:inline-flex;align-items:center;gap:.4rem;background:#111614;color:#82D8B3;border:none;border-radius:100px;padding:.65rem 1.4rem;font-family:inherit;font-size:.85rem;font-weight:700;cursor:pointer;transition:all .2s; }
        .pm-btn-pri:hover:not(:disabled) { background:#4db88a;color:#fff; }
        .pm-btn-pri:disabled { opacity:.6;cursor:not-allowed; }
        .pm-btn-sec { display:inline-flex;align-items:center;gap:.35rem;background:transparent;color:#5a6a63;border:1.5px solid rgba(130,216,179,.3);border-radius:100px;padding:.6rem 1.1rem;font-family:inherit;font-size:.83rem;font-weight:600;cursor:pointer;transition:all .2s; }
        .pm-btn-sec:hover { border-color:#82D8B3;color:#111614; }

        /* Buscador usuario */
        .pm-search-wrap { position:relative; }
        .pm-search-box { display:flex;align-items:center;gap:.5rem;border:1.5px solid rgba(130,216,179,.3);border-radius:10px;padding:.6rem .9rem;background:#fff; }
        .pm-search-box input { flex:1;border:none;outline:none;font-family:inherit;font-size:.88rem;color:#111614; }
        .pm-resultados { position:absolute;top:100%;left:0;right:0;z-index:10;background:#fff;border:1.5px solid rgba(130,216,179,.3);border-top:none;border-radius:0 0 10px 10px;box-shadow:0 8px 24px rgba(0,0,0,.1);max-height:200px;overflow-y:auto; }
        .pm-resultado { display:flex;align-items:center;gap:.7rem;padding:.65rem 1rem;cursor:pointer;transition:background .15s; }
        .pm-resultado:hover { background:#edfaf4; }
        .pm-resultado__av { width:30px;height:30px;border-radius:50%;background:#edfaf4;color:#4db88a;display:flex;align-items:center;justify-content:center;font-size:.8rem;font-weight:700;flex-shrink:0; }
        .pm-resultado strong { display:block;font-size:.85rem;color:#111614; }
        .pm-resultado span { font-size:.75rem;color:#5a6a63; }
        .pm-usuario-sel { display:flex;align-items:center;gap:.8rem;background:#edfaf4;border:1.5px solid #d4f4e8;border-radius:10px;padding:.7rem 1rem; }
        .pm-usuario-sel__av { width:36px;height:36px;border-radius:50%;background:#82D8B3;color:#111614;display:flex;align-items:center;justify-content:center;font-weight:700;flex-shrink:0; }
        .pm-usuario-sel strong { display:block;font-size:.88rem;font-weight:700;color:#111614; }
        .pm-usuario-sel span { font-size:.75rem;color:#5a6a63; }
        .pm-usuario-sel button { margin-left:auto;background:none;border:none;color:#5a6a63;cursor:pointer;font-size:.75rem;text-decoration:underline; }

        /* Productos */
        .pm-tipo-tabs { display:flex;gap:.4rem;margin-bottom:.6rem; }
        .pm-tipo-tab { padding:.35rem .85rem;border-radius:100px;border:1.5px solid rgba(130,216,179,.25);background:#fff;font-family:inherit;font-size:.78rem;font-weight:600;color:#5a6a63;cursor:pointer;transition:all .2s; }
        .pm-tipo-tab--active { background:#111614;color:#82D8B3;border-color:#111614; }
        .pm-prods-lista { display:flex;flex-direction:column;gap:.4rem;max-height:260px;overflow-y:auto; }
        .pm-prod-item { display:flex;align-items:center;justify-content:space-between;gap:.8rem;padding:.75rem 1rem;border:1.5px solid rgba(130,216,179,.2);border-radius:10px;cursor:pointer;transition:all .2s; }
        .pm-prod-item:hover { border-color:#82D8B3;background:#edfaf4; }
        .pm-prod-item--sel { border-color:#4db88a;background:#edfaf4; }
        .pm-prod-item__info { flex:1;min-width:0; }
        .pm-prod-item__titulo { font-size:.88rem;font-weight:700;color:#111614;overflow:hidden;text-overflow:ellipsis;white-space:nowrap; }
        .pm-prod-item__cat { font-size:.72rem;color:#5a6a63; }
        .pm-prod-item__precio { font-size:.95rem;font-weight:800;color:#4db88a;white-space:nowrap; }
        .pm-prod-sel { background:#edfaf4;border:1.5px solid #d4f4e8;border-radius:10px;padding:.8rem 1rem;display:flex;align-items:center;justify-content:space-between; }
        .pm-prod-sel strong { font-size:.9rem;color:#111614; }
        .pm-prod-sel button { background:none;border:none;color:#5a6a63;cursor:pointer;font-size:.75rem;text-decoration:underline;font-family:inherit; }

        /* Resumen */
        .pm-resumen { background:#f9fafb;border-radius:14px;padding:1.2rem;display:flex;flex-direction:column;gap:.6rem; }
        .pm-resumen__row { display:flex;justify-content:space-between;align-items:center;font-size:.85rem; }
        .pm-resumen__row span { color:#5a6a63; }
        .pm-resumen__row strong { color:#111614;font-weight:700; }
        .pm-resumen__total { display:flex;justify-content:space-between;align-items:center;padding-top:.6rem;border-top:1px solid rgba(130,216,179,.2); }
        .pm-resumen__total span { font-size:.9rem;font-weight:700;color:#111614; }
        .pm-resumen__total strong { font-size:1.2rem;font-weight:800;color:#4db88a; }
        .pm-estado-sel { display:grid;grid-template-columns:1fr 1fr;gap:.6rem; }
        .pm-estado-opt { display:flex;flex-direction:column;align-items:center;gap:.3rem;padding:.9rem;border:1.5px solid rgba(130,216,179,.2);border-radius:12px;cursor:pointer;transition:all .2s;background:#fff; }
        .pm-estado-opt--active.pm-estado-opt--validado { border-color:#4db88a;background:#edfaf4; }
        .pm-estado-opt--active.pm-estado-opt--pendiente { border-color:#f59e0b;background:#fffbeb; }
        .pm-estado-opt__icon { font-size:1.4rem; }
        .pm-estado-opt strong { font-size:.82rem;font-weight:700;color:#111614; }
        .pm-estado-opt small { font-size:.72rem;color:#5a6a63;text-align:center;line-height:1.4; }
      `}</style>

      <div className="pm-overlay" onClick={onClose}>
        <div className="pm-modal" onClick={e => e.stopPropagation()}>

          {/* Cabecera */}
          <div className="pm-head">
            <div style={{display:'flex',alignItems:'center',gap:'.6rem'}}>
              <IconMoney/>
              <h2>Registrar pago manual</h2>
            </div>
            <button className="pm-close" onClick={onClose}><IconClose/></button>
          </div>

          {/* Steps */}
          <div className="pm-steps">
            {PASO_LABELS.map((label, i) => (
              <div key={i} className={'pm-step ' + (paso === i+1 ? 'pm-step--active' : paso > i+1 ? 'pm-step--done' : '')}>
                <div className="pm-step__num">
                  {paso > i+1 ? <IconCheck/> : i+1}
                </div>
                {label}
              </div>
            ))}
          </div>

          {/* ══ PASO 1: CLIENTE ══ */}
          {paso === 1 && (
            <div className="pm-body">
              <p style={{fontSize:'.82rem',color:'#5a6a63',margin:0}}>
                Busca un usuario existente o ingresa los datos manualmente.
              </p>

              {/* Buscador */}
              {!form.nombre && !modoManual && (
                <div className="pm-field">
                  <label><IconSearch/> Buscar usuario por nombre o email</label>
                  <div className="pm-search-wrap">
                    <div className="pm-search-box">
                      <IconSearch/>
                      <input
                        type="text"
                        placeholder="Escribe nombre o email…"
                        value={busEmail}
                        onChange={e => setBusEmail(e.target.value)}
                        autoFocus
                      />
                      {buscando && <IconSpinner/>}
                    </div>
                    {resultados.length > 0 && (
                      <div className="pm-resultados">
                        {resultados.map(u => (
                          <div key={u.id} className="pm-resultado" onClick={() => seleccionarUsuario(u)}>
                            <div className="pm-resultado__av">{(u.nombre||'U')[0].toUpperCase()}</div>
                            <div>
                              <strong>{u.nombre} {u.apellido}</strong>
                              <span>{u.email}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => setModoManual(true)}
                    style={{alignSelf:'flex-start',background:'none',border:'none',color:'#4db88a',cursor:'pointer',fontSize:'.8rem',fontFamily:'inherit',fontWeight:600,padding:0,marginTop:'.2rem'}}
                  >
                    + Ingresar datos manualmente
                  </button>
                </div>
              )}

              {/* Usuario seleccionado */}
              {form.nombre && !modoManual && (
                <div className="pm-usuario-sel">
                  <div className="pm-usuario-sel__av">{form.nombre[0].toUpperCase()}</div>
                  <div>
                    <strong>{form.nombre}</strong>
                    <span>{form.email}</span>
                  </div>
                  <button onClick={() => { setForm(INIT_FORM); setBusEmail(''); }}>Cambiar</button>
                </div>
              )}

              {/* Formulario manual */}
              {modoManual && (
                <>
                  <div className="pm-grid2">
                    <div className="pm-field">
                      <label>Nombre completo <span className="pm-req">*</span></label>
                      <input type="text" placeholder="Ej: Ana García" value={form.nombre} onChange={e => setF('nombre', e.target.value)}/>
                    </div>
                    <div className="pm-field">
                      <label>Email <span className="pm-req">*</span></label>
                      <input type="email" placeholder="cliente@email.com" value={form.email} onChange={e => setF('email', e.target.value)}/>
                    </div>
                  </div>
                  <div className="pm-field">
                    <label>Teléfono / WhatsApp</label>
                    <input type="tel" placeholder="9XX XXX XXX" value={form.telefono} onChange={e => setF('telefono', e.target.value)}/>
                  </div>
                  <button
                    onClick={() => { setModoManual(false); setForm(INIT_FORM); }}
                    style={{alignSelf:'flex-start',background:'none',border:'none',color:'#5a6a63',cursor:'pointer',fontSize:'.78rem',fontFamily:'inherit',textDecoration:'underline',padding:0}}
                  >
                    ← Buscar usuario existente
                  </button>
                </>
              )}
            </div>
          )}

          {/* ══ PASO 2: PRODUCTO ══ */}
          {paso === 2 && (
            <div className="pm-body">

              {/* Producto seleccionado o selector */}
              {form.producto_titulo ? (
                <div className="pm-prod-sel">
                  <div>
                    <strong>{form.producto_titulo}</strong>
                    <span style={{display:'block',fontSize:'.75rem',color:'#5a6a63',marginTop:'.15rem'}}>
                      {form.fuente === 'curso' ? 'Curso' : 'Recurso'} · S/. {parseFloat(form.precio).toFixed(2)}
                    </span>
                  </div>
                  <button onClick={() => setForm(p => ({ ...p, producto_id:'', producto_titulo:'', precio:'' }))}>
                    Cambiar
                  </button>
                </div>
              ) : (
                <>
                  <div className="pm-tipo-tabs">
                    {[{val:'todos',label:'Todos'},{val:'recurso',label:'Recursos'},{val:'curso',label:'Cursos'}].map(t => (
                      <button key={t.val} className={'pm-tipo-tab ' + (filtroTipo===t.val?'pm-tipo-tab--active':'')} onClick={() => setFiltroTipo(t.val)}>{t.label}</button>
                    ))}
                  </div>


                  <div style={{
  display:'flex', alignItems:'center', gap:'.5rem',
  border:'1.5px solid rgba(130,216,179,.3)', borderRadius:10,
  padding:'.55rem .9rem', background:'#fff',
}}>
  <IconSearch/>
  <input
    type="text"
    placeholder="Buscar producto…"
    value={busProducto}
    onChange={e => setBusProducto(e.target.value)}
    style={{flex:1, border:'none', outline:'none', fontFamily:'inherit', fontSize:'.88rem', color:'#111614'}}
  />
  {busProducto && (
    <button
      onClick={() => setBusProducto('')}
      style={{background:'none', border:'none', cursor:'pointer', color:'#9ca3af', display:'flex'}}
    >
      <IconClose/>
    </button>
  )}
</div>

                  {loadProd ? (
                    <div style={{textAlign:'center',padding:'1.5rem',color:'#5a6a63',fontSize:'.85rem'}}><IconSpinner/> Cargando productos…</div>
                  ) : (
                    <div className="pm-prods-lista">
                      {prodFiltrados.map(p => (
                        <div key={p.id} className={'pm-prod-item ' + (form.producto_id===p.id?'pm-prod-item--sel':'')} onClick={() => seleccionarProducto(p)}>
                          <div className="pm-prod-item__info">
                            <div className="pm-prod-item__titulo">{p.titulo.replace(/^\[Curso\] /,'')}</div>
                            <div className="pm-prod-item__cat">{p.fuente === 'curso' ? '🎓 Curso' : '📄 Recurso'} · {p.categoria}</div>
                          </div>
                          <div className="pm-prod-item__precio">S/. {parseFloat(p.precio).toFixed(2)}</div>
                        </div>
                      ))}
                      {prodFiltrados.length === 0 && (
                        <div style={{textAlign:'center',padding:'1.5rem',color:'#9ca3af',fontSize:'.83rem'}}>Sin productos en esta categoría</div>
                      )}
                    </div>
                  )}
                </>
              )}

              {/* Precio editable */}
              {form.producto_titulo && (
                <div className="pm-grid2">
                  <div className="pm-field">
                    <label>Precio cobrado (S/.) <span className="pm-req">*</span></label>
                    <input type="number" step="0.01" min="0" placeholder="0.00" value={form.precio} onChange={e => setF('precio', e.target.value)}/>
                    <small style={{fontSize:'.7rem',color:'#9ca3af'}}>Puedes modificar el precio si hubo descuento</small>
                  </div>
                  <div className="pm-field">
                    <label>Método de pago</label>
                    <select value={form.metodo_pago} onChange={e => setF('metodo_pago', e.target.value)}>
                      {METODOS.map(m => <option key={m.val} value={m.val}>{m.label}</option>)}
                    </select>
                  </div>
                </div>
              )}

              {form.producto_titulo && (
                <div className="pm-grid2">
                  <div className="pm-field">
                    <label>N° de operación / referencia</label>
                    <input type="text" placeholder="Opcional" value={form.referencia_pago} onChange={e => setF('referencia_pago', e.target.value)}/>
                  </div>
                  <div className="pm-field">
                    <label>Notas internas</label>
                    <input type="text" placeholder="Ej: Pago en efectivo en oficina" value={form.notas} onChange={e => setF('notas', e.target.value)}/>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* ══ PASO 3: CONFIRMAR ══ */}
          {paso === 3 && (
            <div className="pm-body">

              {/* Resumen */}
              <div className="pm-resumen">
                <div className="pm-resumen__row"><span>Cliente</span><strong>{form.nombre}</strong></div>
                <div className="pm-resumen__row"><span>Email</span><strong>{form.email}</strong></div>
                {form.telefono && <div className="pm-resumen__row"><span>Teléfono</span><strong>{form.telefono}</strong></div>}
                <div className="pm-resumen__row"><span>Producto</span><strong>{form.producto_titulo}</strong></div>
                <div className="pm-resumen__row"><span>Tipo</span><strong>{form.fuente === 'curso' ? '🎓 Curso' : '📄 Recurso'}</strong></div>
                <div className="pm-resumen__row"><span>Método</span><strong>{METODOS.find(m => m.val === form.metodo_pago)?.label || form.metodo_pago}</strong></div>
                {form.referencia_pago && <div className="pm-resumen__row"><span>Referencia</span><strong>{form.referencia_pago}</strong></div>}
                {form.notas && <div className="pm-resumen__row"><span>Notas</span><strong>{form.notas}</strong></div>}
                <div className="pm-resumen__total">
                  <span>Total</span>
                  <strong>S/. {parseFloat(form.precio).toFixed(2)}</strong>
                </div>
              </div>

              {/* Estado final */}
              <div className="pm-field">
                <label>¿Cómo registrar el pedido?</label>
                <div className="pm-estado-sel">
                  <div
                    className={'pm-estado-opt pm-estado-opt--validado ' + (form.estado === 'validado' ? 'pm-estado-opt--active' : '')}
                    onClick={() => setF('estado', 'validado')}
                  >
                    <span className="pm-estado-opt__icon">✅</span>
                    <strong>Pago confirmado</strong>
                    <small>Activa acceso inmediato, acumula puntos y envía email al cliente</small>
                  </div>
                  <div
                    className={'pm-estado-opt pm-estado-opt--pendiente ' + (form.estado === 'pendiente' ? 'pm-estado-opt--active' : '')}
                    onClick={() => setF('estado', 'pendiente')}
                  >
                    <span className="pm-estado-opt__icon">⏳</span>
                    <strong>Crear como pendiente</strong>
                    <small>El pedido queda registrado y se puede validar después</small>
                  </div>
                </div>
              </div>

              {form.estado === 'validado' && (
                <div style={{background:'#edfaf4',border:'1px solid #d4f4e8',borderRadius:10,padding:'.8rem 1rem',fontSize:'.8rem',color:'#065f46',lineHeight:1.6}}>
                  <strong>Al confirmar:</strong> se activará el acceso del cliente, se acumularán puntos y se enviará un email de confirmación a <strong>{form.email}</strong>.
                </div>
              )}
            </div>
          )}

          {/* Footer */}
          <div className="pm-foot">
            <div>
              {paso > 1 && (
                <button className="pm-btn-sec" onClick={() => setPaso(p => p - 1)}>
                  ← Anterior
                </button>
              )}
            </div>
            <div style={{display:'flex',gap:'.6rem'}}>
              <button className="pm-btn-sec" onClick={onClose}>Cancelar</button>
              {paso < 3 ? (
                <button
                  className="pm-btn-pri"
                  onClick={() => setPaso(p => p + 1)}
                  disabled={!puedeAvanzar()}
                >
                  Siguiente →
                </button>
              ) : (
                <button className="pm-btn-pri" onClick={guardar} disabled={guardando}>
                  {guardando
                    ? <><IconSpinner/> Registrando…</>
                    : form.estado === 'validado'
                      ? <><IconCheck/> Confirmar pago</>
                      : <><IconCheck/> Crear pedido</>
                  }
                </button>
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );
}